<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.01 35.51">
    <g id="Capa_2" data-name="Capa 2">
      <g id="Capa_1-2" data-name="Capa 1">
        <path
          d="M31,35.51l-8.18-7.4.87,3.19H4.09C1.45,31.29,0,29.84,0,27.19V4.08C0,1.48,1.46,0,4,0H27a3.67,3.67,0,0,1,4,4q0,15.27,0,30.55ZM9.14,20.24,9.26,20a13.09,13.09,0,0,0,12.83,0l.11.27L19.36,22c.55.41,1.08,1.14,1.63,1.15a5.81,5.81,0,0,0,4.64-2.24,1.58,1.58,0,0,0,.31-.94,23.43,23.43,0,0,0-2.28-9.26,1.85,1.85,0,0,0-.57-.75,8.09,8.09,0,0,0-4.25-1.6,4.52,4.52,0,0,0-.66.09l3.61,1.7-.07.23A15.51,15.51,0,0,0,9,10.42l-.07-.2L13,8.31A7.62,7.62,0,0,0,8.65,9.58a3.57,3.57,0,0,0-1.19,1.34,26.2,26.2,0,0,0-2.14,7.74A3.15,3.15,0,0,0,7.2,22.25a7.79,7.79,0,0,0,1.63.68c1.68.49,2,.36,2.86-1.13Z"
          class="cls-1"
        />
        <path
          d="M20.56,16.8a2,2,0,0,1-1.95,2,2,2,0,0,1,0-4A1.9,1.9,0,0,1,20.56,16.8Z"
          class="cls-1"
        />
        <path
          d="M14.09,16.69a1.8,1.8,0,0,1-1.76,1.83,1.82,1.82,0,1,1,1.76-1.83Z"
          class="cls-1"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "DiscorSvg",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.cls-1 {
  fill: #fff;
}
</style>
